import React, { useState } from 'react'
import NavMenu from './NavMenu'
import logoMini from '../../assets/logos/stackcoding-logo-dark.png'
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  }

  return (
    <header id="header" className={`header dark-background-sc d-flex flex-column ${isMenuOpen ? 'header-show' : ''}`}>
      <button className='header-toggle d-xl-none' onClick={toggleMenu}>
        <i className={`header-toggle bi ${isMenuOpen ? 'bi-x' : 'bi-list'}`}></i>
      </button>
      <Link to="/" className="p-2 d-flex align-items-center justify-content-center mt-2">
        <img src={logoMini} alt="" className="img-fluid w-100"></img>
      </Link>

      <div className="social-links text-center">
        <a href="#" className="twitter"><i className="bi bi-twitter-x"></i></a>
        <a href="#" className="facebook"><i className="bi bi-facebook"></i></a>
        <a href="https://www.instagram.com/stackcoding.sv/" target="_blank" rel="noreferrer" className="instagram"><i className="bi bi-instagram"></i></a>
        <a href="#" className="linkedin"><i className="bi bi-linkedin"></i></a>
      </div>
      <NavMenu></NavMenu>
    </header>
  )
}

export default Header